// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner-module--banner--25TFu"};